export default __webpack_public_path__ + "static/media/icon-big-coins-88-px.da2e9acd.svg";